import {Route, Routes, useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import baseUrl from "../../baseUrl";
import {CompanyInfoModal} from "../CompanyInfoModal/CompanyInfoModal";
import {useAuthContext} from "../../contexts/AuthContext";
import {useNavigate} from "react-router-dom";
import {SettlementCompany} from "./SettlementCompany/SettlementCompany";
import {SettlementDealCompany} from "./SettlementDealCompany/SettlementDealCompany";
import {SettlementDeals} from "./SettlementDeals/SettlementDeals";
import {requester} from "../../services/requester";
import {RouteGuard} from "../common/RouteGuard";
import {DeclarationsCompare} from "../Declarations/DeclarationsCompare";
import {settlementLabel} from "../../utils/settlements";


export const SettlementCompanies = () => {
    const navigate = useNavigate();
    const request = requester();
    const {setLocalStorageState} = useAuthContext();
    const {year, settlement_ekatte} = useParams();
    const [settlements, setSettlements] = useState([]);
    const [deals, setDeals] = useState([]);
    const [settlement, setSettlement] = useState('');
    const [settlements_name, setSettlements_name] = useState([]);
    const [drawnSums, setDrawnSums] = useState({}); // Е1: {bullstat: изчертано} за подредба
    // П1: {bullstat: {verified, total}} — за зеленото оцветяване на приключените.
    const [verifiedCounts, setVerifiedCounts] = useState({});
    const [modalInfo, setModalInfo] = useState(
        {
            "phone": "",
            "company_name": "",
            "create_on": "",
            "accountable_person": "",
            "address": "",
            "city": "",
            "id": "",
            "bullstat": "",
            "settlements": [],
            "company_note": ""
        }
    );

    // ЧАСТ К: кои ползватели тук имат замяна, която иска внимание — за червената
    // икона пред името. Целият механизъм се крепи на това: ако сигналът не
    // стигне до човека, разминаването остава завинаги.
    const [pendingFlags, setPendingFlags] = useState({to_approve: [], my_attention: []});

    useEffect(() => {
        request.get(`${baseUrl()}/deals/pending/${year}/${settlement_ekatte}`)
            .then(setPendingFlags)
            .catch(() => setPendingFlags({to_approve: [], my_attention: []}));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [year, settlement_ekatte]);

    useEffect(() => {
        Promise.all([
            request.get(`${baseUrl()}/companies-initial-info/${year}/${settlement_ekatte}`),
            request.get(`${baseUrl()}/deals/${year}/${settlement_ekatte}`),
            request.get(`${baseUrl()}/drawings/sums/${year}/${settlement_ekatte}`)
        ])
            .then(([dataSettlement, dataDeals, dataDrawnSums]) => {
                if (dataSettlement.message) {
                    setLocalStorageState({})
                    navigate("/login")
                }
                setSettlements(dataSettlement);
                setSettlement(settlementLabel(dataSettlement[0].settlement));

                for (let i = 0; i < dataSettlement.length; i++) {
                    setSettlements_name(state => [...state, dataSettlement[i].bullstat]);
                }

                setDeals(dataDeals.filter(deal => deal.amount > 0));
                setDrawnSums(dataDrawnSums?.sums || {});
                setVerifiedCounts(dataDrawnSums?.verified || {});

            })

    }, [year, settlement_ekatte]);

    // Е1: подреждаме двете таблици низходящо по изчертана площ при всяко
    // зареждане (списъкът се презарежда при връщане от страницата на ползвателя,
    // затова промените се отразяват в подредбата). Редовите компоненти НЕ се пипат.
    const byDrawnDesc = (a, b) =>
        (drawnSums[String(b.bullstat)] || 0) - (drawnSums[String(a.bullstat)] || 0);
    const sortedSettlements = [...settlements].sort(byDrawnDesc);
    const newDeals = deals
        .filter(deal => !settlements_name.includes(deal.bullstat))
        .sort(byDrawnDesc);

    const modalInfoHandler = (info) => {
        setModalInfo(info);
    }

    return (
        <div>
            <CompanyInfoModal info={modalInfo}/>
            {settlement && (
                <div className="d-flex justify-content-center mt-3">
                    <span className="badge fs-5 px-4 py-2" style={{backgroundColor: "var(--app-gold)"}}>
                        {settlement}
                    </span>
                </div>
            )}

            <Routes element={<RouteGuard/>}>
                <Route path="/companies/" element={<div>
                    <h5 className="d-flex justify-content-center mt-3 mb-3" style={{color: "var(--app-gold)"}}>Ползватели
                        първоначално декларирали земя в
                        землището</h5>
                    <table className="table">
                        <thead>
                        <tr>
                            {/* К: сигнална колона — чакащо или отказано одобрение */}
                            <th scope="col"></th>
                            <th scope="col"></th>
                            <th scope="col">Ползвател</th>
                            <th scope="col">Булстат</th>
                            <th scope="col">Декларирана</th>
                            <th scope="col">Необработваема</th>
                            <th scope="col">Годна</th>
                            <th scope="col">ДЗ</th>
                            <th scope="col">БП</th>
                            <th scope="col">Правно</th>
                            <th scope="col">Изчертано</th>
                            <th scope="col"></th>
                        </tr>
                        </thead>
                        <tbody>
                        {sortedSettlements.map(settlement => (<SettlementCompany key={settlement.id} {...settlement}
                                                                           pendingFlags={pendingFlags}
                                                                           verifiedInfo={verifiedCounts[String(settlement.bullstat)]}
                                                                           modalInfoHandler={modalInfoHandler}/>))}
                        </tbody>
                    </table>
                    <h5 className="d-flex justify-content-center mt-3 mb-3" style={{color: "var(--app-gold)"}}>Ползватели
                        получили земя, чрез ДЗ</h5>
                    <table className="table">
                        <thead>
                        <tr>
                            <th scope="col"></th>
                            <th scope="col">Ползвател</th>
                            <th scope="col">Булстат</th>
                            <th scope="col">Декларирана</th>
                            <th scope="col">Необработваема</th>
                            <th scope="col">Годна</th>
                            <th scope="col">ДЗ</th>
                            <th scope="col">БП</th>
                            <th scope="col">Правно</th>
                            <th scope="col">Изчертано</th>
                            <th scope="col"></th>
                        </tr>
                        </thead>
                        <tbody>
                        {newDeals.map(settlement => (
                            <SettlementDealCompany key={settlement.id} {...settlement} year={year}
                                                   modalInfoHandler={modalInfoHandler}/>))}
                        </tbody>
                    </table>
                </div>}/>
                <Route path="/deals/" element={<div>
                    <h5 className="d-flex justify-content-center mt-3 mb-3" style={{color: "var(--app-gold)"}}>Направени ДЗ
                        в това
                        землище до момента</h5>
                    <table className="table">
                        <thead>
                        <tr>
                            <th scope="col">Получил в селото</th>
                            <th scope="col">Дал в селото</th>
                            <th scope="col">За село</th>
                            <th scope="col">Сума</th>
                        </tr>
                        </thead>
                        <tbody>
                        {deals.map(deal => (<SettlementDeals key={deal.id} {...deal} year={year}/>))}
                        </tbody>
                    </table>
                </div>}/>
                <Route path="/compare" element={<DeclarationsCompare/>}/>
            </Routes>
        </div>
    );
};